import React from "react";
import { IconButton, Tooltip } from "@govlaunch/web";
import BookmarkIcon from "~/components/icons/Collections/BookmarkIcon";
import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";
import { IListAllCollectionsQuery } from "~/src/components/collection/graphql/__generated__/ListCollectionsQuery.generated";
import { useIntl } from "react-intl";

interface IBundleBookmarkButtonProps {
  collection: IListAllCollectionsQuery["listAllCollections"]["items"][0];
  selfie: ISelfieQuery["selfie"] | null;
  signInModal: any;
  onToggleBookmark: any;
}

export default function BookmarkButton({
  collection,
  selfie,
  signInModal,
  onToggleBookmark,
}: IBundleBookmarkButtonProps) {
  const intl = useIntl();

  return (
    <Tooltip
      label={intl.formatMessage({
        defaultMessage: 'Save collection', id: 'b+ygF6',
      })}
      bg="teal.600"
      p={2}
    >
      <IconButton
        position="absolute"
        top="4px"
        right="4px"
        width="20px"
        height="28px"
        aria-label={intl.formatMessage({
          defaultMessage: 'Bookmark', id: 'Rs4kCE',
        })}
        color="gray.400"
        zIndex={1}
        size="xs"
        p={0}
        _hover={{
          color: "teal.600",
        }}
        data-intercom-target="Bookmark collection"
        onClick={(event: React.SyntheticEvent) => {
          event.preventDefault();
          if (selfie) {
            onToggleBookmark(collection);
          } else {
            signInModal.open();
          }
        }}
        icon={() => <BookmarkIcon viewerDidBookmark={collection.viewerDidBookmark} borderColor="white" />}
      />
    </Tooltip>
  );
}
